const capacity_values = {
}

export default capacity_values
